import CallbackConfig from './callback/CallbackConfig';
import ForgotPasswordConfig from './forgot-password/ForgotPasswordConfig';
import LockPageConfig from './lock-page/LockPageConfig';
import LoginConfig from './login/LoginConfig';
import MailConfirmConfig from './mail-confirm/MailConfirmConfig';
import RegisterConfig from './register/RegisterConfig';
import ResetPasswordConfig from './reset-password/ResetPasswordConfig';

const authConfig = [
  CallbackConfig,
  ForgotPasswordConfig,
  LockPageConfig,
  LoginConfig,
  LoginConfig,
  MailConfirmConfig,
  RegisterConfig,
  ResetPasswordConfig,
];

export default authConfig;
